import { IShopifyData } from "../../../../ShopifyData";
import { emailBodySection } from "../../../components/emailBody";
import { emailButton } from "../../../components/emailButton";
import { emailFrame } from "../../../components/emailFrame";
import { emailHeader } from "../../../components/emailHeader";
import { emailQuestionSection } from "../../../components/emailQuestions";

export function createDefaultItemOutOfStockRemovalEmailBody(shopifyData: IShopifyData) {
  return emailFrame(
    emailHeader(
      `One of your items<% if(outOfStockItem.unavailableReason === 'out_of_stock'){ %> is out of stock <% } else { %> is no longer available <% } %>`
    ),
    emailBodySection(
      `<%- outOfStockItem.name %> <% if(outOfStockItem.variantName !== 'Default Title'){ %>- <%- outOfStockItem.variantName %><% } %><% if(outOfStockItem.unavailableReason === 'out_of_stock'){ %> is currently out of stock<% } else { %> is no longer available<% } %>. The item has been moved to your next scheduled subscription order.`
    ),
    emailBodySection("You can manage your subscription below."),
    emailButton("Manage my subscription", `https://${shopifyData.domain}/account`),
    emailQuestionSection(shopifyData)
  );
}
